var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-10 mr-10"},[_c('highcharts',{ref:"lineCharts",staticClass:"chart",attrs:{"options":_vm.chartsetting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }